
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexX9t4FVb7OyXkKsfSt4F8e1wxFAJZsUuvTAGCMXxtE_AMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/index.vue?macro=true";
import { default as loginjqJg3PVgpmzxLQXzQhjB5T82owLgVI0QahJnMVOm4osMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/login.vue?macro=true";
import { default as _91key_932ACm6AYdUAPaUyGMP97qPUxL5YgENj7oqmB2JKR61rkMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/s/[key].vue?macro=true";
import { default as mgen_45tD6_45QL0y6JDUtWCOuyRck_45JaXlOTJ9NbfFVZCRosZAMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/quiz/mgen.vue?macro=true";
import { default as indexmljeiYF4LkE3y_45OLOJddKQfqycLvR4wx_45BBlE_45pFv5AMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/index.vue?macro=true";
import { default as notesm7IOFz6FkF_45XbOG8HKMJ4O4e5Psi95j_455NtL_45Prxp7gMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/notes.vue?macro=true";
import { default as indexljHERAKvn5s0UkC4GBozySRQZtFXL3CGO4Md0fbB_45yAMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/stats/index.vue?macro=true";
import { default as en_45ce_45momentqOrgh7pOc_Jw2ZqC4dWYJmJvEfF8WvdCEYOb1P_45QTdEMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/en-ce-moment.vue?macro=true";
import { default as plan_45du_45siteu5x9I90DomtqZ3hlv8hIPG6UTFs8LDQYL_45gv8s__45Q1wMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/plan-du-site.vue?macro=true";
import { default as editbU8ldTkmLonnoYH8M6T18mqQOqigKBqMsLkAYMswyQQMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/profile/edit.vue?macro=true";
import { default as places6alDxoC5GM76bTOOLVUhfkcyK_ViqoL4ABV9_yp_45isIMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/stats/places.vue?macro=true";
import { default as accessibilite_z4oElq4kR8Dc1SbDj6eYzgW2Y0_45hiji5BfdaKmeM_oMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/accessibilite.vue?macro=true";
import { default as _91id_93BWZP5K8t_456M1eYX1RDva_fJdjm2yKlXXJsr8LoA9JLsMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/messages/[id].vue?macro=true";
import { default as notificationsAfuVPC391OKa0hBIkPolLCK9OkCveyrUDmuV7QANJikMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/notifications.vue?macro=true";
import { default as indexkOX3eEsAvwlulVChMacvEuEcft5DJvlZTSsiheD5PgcMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/profile/index.vue?macro=true";
import { default as index_WqIziwfjDPyGuZVF34_45ikfxaVlSnX9oIKdwpvCtxuUMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/support/index.vue?macro=true";
import { default as _91slug_93A8LHN3h2t75Ey4BpCXtOtyiPxzccaffo_8b5Y7h7u3gMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/villes/[slug].vue?macro=true";
import { default as indexKtTM9Q5_45GyYQfWX_iYRI6a_eymnIyOKEgybyvRz2NtIMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/messages/index.vue?macro=true";
import { default as generique9Qv6SUIS0uutCsNTEBB5eEbJEpwrdqqibDokytBNmuIMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/quiz/generique.vue?macro=true";
import { default as _91slug_93iWGrA0ezCoVYbN2BDyrrtR6L3fQeWMGNzS0sSkL2Qt4Meta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/reseaux/[slug].vue?macro=true";
import { default as missionsBaG70HbNjP2ohRDlLy_4552dLiqqv7xFoBohC6q_uF1qIMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/stats/missions.vue?macro=true";
import { default as indexacYmiii7KwDSlN88SNi1PAygxOLnDTeEHJpY4b4GHIcMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/dashboard/index.vue?macro=true";
import { default as favorisLXfUjDN6TdnYXcKkJXOyEjwTrjvdXCBwTvOX0vSWz9gMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/profile/favoris.vue?macro=true";
import { default as _91slug_93NGzkiaJx8biQTrRLLJXsdHu4dfCUfRpGNiiq_455TF_45eYMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/activites/[slug].vue?macro=true";
import { default as logsQ_3nVudBWbqg2p_45Pqt8BpOfJHvIaPeyQgMcKU2tm5ZsMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/other/logs.vue?macro=true";
import { default as ressourcesU6pAqqRkXBZYAWvg0LsxzFXNQMR0LIQPMg2Fbnq76J4Meta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/ressources.vue?macro=true";
import { default as mentions_45legalesAQT4IoJoi0GMTLS9O6GIZt8LiMKfSWIKdUjpkdEs__45YMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/mentions-legales.vue?macro=true";
import { default as missionssMvvCAzij3_uNKi8X5MN8jWkK9mjzyK13_kzEK_45EU5IMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/profile/missions.vue?macro=true";
import { default as settingsj8LQqT3YzoeXTyQ3CPRIU_45xAKkNus7vYtoGnAJWPjuYMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/profile/settings.vue?macro=true";
import { default as tournee_45ete_HeXGRbfq3HN_45vwYb59IBAeplUXzQ4xPCOcxhgA3RUMMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/quiz/tournee-ete.vue?macro=true";
import { default as temoignagesmY68vj78PePvrTUk8iVbdlkkiNySDvKsF0qaRRcMX2QMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/temoignages.vue?macro=true";
import { default as indexRQcze9Z1qbaSinA_45dqAqiT3qmWKCD_v5qeaVOsAVcYwMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/inscription/index.vue?macro=true";
import { default as adminOSwXuneV7zlo_45CqgPcHliiKr1uOiXkVOZrGG_vMwHQEMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/maintenance/admin.vue?macro=true";
import { default as indexmKM1SSE27SU_2KcL9R150NPFVJlqwHWWqa61zkfdChgMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/maintenance/index.vue?macro=true";
import { default as indexJpeSSvIzeSrHP6wJeCt7R8gwMTjYR7xtA8Tvq1tW_N8Meta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/territoires/index.vue?macro=true";
import { default as _91hash_93NW49Lq81JRjqz3kghCgo_45hJVTULbXEfiUOb99HO1h8MMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/invitations/[hash].vue?macro=true";
import { default as utilisateursDUDxCu11J4hXgt4oF_yTlDTLPHauUsDjlP6Wt_WVzvQMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/stats/utilisateurs.vue?macro=true";
import { default as _91slug_93dmOdq5fv9RekiFMGRdlqpooEF1s2Ka56MRou8JwPLtYMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/associations/[slug].vue?macro=true";
import { default as _91slug_93pFDEiM9Vqgn2DeASF1IFXuO3lYp078A_456kb_KtcRuVsMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/departements/[slug].vue?macro=true";
import { default as indexP8pSoKUxtMQIDqbxRjTQdw_OA_45ODckvUo6bhpar7G8EMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/organisations/index.vue?macro=true";
import { default as preferencesZLpVz2Rl5KXRs8iEPFc_BsPZXd1bWpp1J1zI7G38wf8Meta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/profile/preferences.vue?macro=true";
import { default as organisations1LmNXpl5pf1AAHkyE09qx_45Fu0avJhR8kcHKWVgxadu8Meta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/stats/organisations.vue?macro=true";
import { default as _91token_93jJnGtecWo3URsWCsp7JR03W88m2t7Wvewu1JANFqlaAMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/temoignages/[token].vue?macro=true";
import { default as postsUPWSALmYB9anWbOAMvNluIvtfx_45hN9LjJUaZKZYg55wMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/posts.vue?macro=true";
import { default as indexFsxOmCg3ZBe7q3w9ZZv9oV_UmVnyERSR4mayGaBRfVgMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/missions/index.vue?macro=true";
import { default as addQZ3vOePGwTWdPBkJKaUZyH0HrHMt1oU_7ABrdFhr3PIMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/messages/modeles/add.vue?macro=true";
import { default as _91slug_934RThx_PBTlXJ9E5UvzXwv_45lUyPPez8B9F0vFN_SUC_458Meta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/organisations/[slug].vue?macro=true";
import { default as indexERU3PdviWR3urA2mzwgj0AGGXJ0VTqFtV7JctDYtmFoMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/password-reset/index.vue?macro=true";
import { default as participations5rMJFKjkNBt9Vh_45mshmGXt9ylFn0WwMcf_454mlCRdB_AMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/stats/participations.vue?macro=true";
import { default as emailsUu36TAU3T6FLEz8sAfLkfL5BkvlDGoQwu5CXiaS5h1EMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/settings/emails.vue?macro=true";
import { default as indexNT3J9gR0NUhnTaC1EZzPMjBkrSd0EemvHXBzX6HTTqgMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/profile/alertes/index.vue?macro=true";
import { default as notifications0eq_IP0orF3BsTFdU8mvsgOoJeB8htrfbj7005rZ7U0Meta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/profile/notifications.vue?macro=true";
import { default as index8yUCSS4ZXIRF_45hk_rlUwQxPePkF3lfMQ9HA8CVhGS9YMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/statistics/index.vue?macro=true";
import { default as charte_45reserve_45civique7Um_jCUJy8SQoounY_45ocKQMSLDrsjbFtqXlpzo2CwpcMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/charte-reserve-civique.vue?macro=true";
import { default as _91slug_93FnF_45DuKPFOvjLPMrLgsHnmYdcnSqzCQy2cOSRkEXekIMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/domaines-action/[slug].vue?macro=true";
import { default as indexdh1AM_45Z_45DhGIgGJZ9UDBD7lQzscCiCZlcaJago4wXE8Meta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/messages/modeles/index.vue?macro=true";
import { default as _91token_93djXeIG8zgLoYRX4ddUq_OqY3VNb71UergcxQL2uqwNgMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/password-reset/[token].vue?macro=true";
import { default as decembre_45ensembleZ7vnptWTKFL6h5Bhk3YWfYtSj287JqFgJhlYTijQVA0Meta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/quiz/decembre-ensemble.vue?macro=true";
import { default as invitationso9_45BppS28RgVWnad4QXHr8hPaOr7ak_6jjA57JAS2XsMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/other/invitations.vue?macro=true";
import { default as messagesb1_45Xfk_45Yx2g_P4M18FUt12juXWGMPxN6xcZB98jqNAUMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/settings/messages.vue?macro=true";
import { default as placesMdlsxNPfOimELx2HO6N2Bk6AzmQNBxGkpUMxb7p7BBIMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/statistics/places.vue?macro=true";
import { default as addNgqCjN9LqgQxtbpPjCAKN4ReCAnPZGKRPKn5QfOZnlUMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/settings/rules/add.vue?macro=true";
import { default as index60JvTYwcQB_45oMMgV2fltF_vaogwxerV_SIWJMZBQh9kMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/utilisateurs/index.vue?macro=true";
import { default as indexjgzcFC0kHjV_1UGTBuGr7rJoAqDEy0l45yow56hovGcMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/missions-benevolat/index.vue?macro=true";
import { default as datesEkmJdDo5hAee_nmxGmun2IcMVmyE_45iSINkI6wrptOkgMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/missions/[id]/dates.vue?macro=true";
import { default as indexQlfzwdAl7p_45B2JApbQysQ0zU0bC29FesStZhDamZUesMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/missions/[id]/index.vue?macro=true";
import { default as lieuxxYLvPrGnVXDGmlclkisaljQpmHopNntbneDkOxEDMb4Meta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/missions/[id]/lieux.vue?macro=true";
import { default as titlet6ALlztB0SG0wKgIn6fp3vaQE5IcLIAWC1rP2iQWg0QMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/missions/[id]/title.vue?macro=true";
import { default as index240d0dlKDwnGFJtNQA8gDuE7XZLX8crFHRJuno5xO3IMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/organisations/index.vue?macro=true";
import { default as missionsuhmBVI9v3ObhxuIneDGlXr_45BrvqbqlsnHonITfMumSgMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/statistics/missions.vue?macro=true";
import { default as addJo_uaH0Z41n22ZpVaHsBc1GF0P2QL0okLQYqosKSogQMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/reseaux/add.vue?macro=true";
import { default as visueld4bRFDYNXET3nJDY5jzpK5VFuMLb2PrDExxDqbDCbpAMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/missions/[id]/visuel.vue?macro=true";
import { default as indexuPbMeT_45qvM3mZZVLkdc84N8WKeesYaMckocHq8yDywUMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/participations/index.vue?macro=true";
import { default as indexdFvDYhYCMlK8h0RYfz4XIu4ka9ZaqvIov7CwWB0_45HFMMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/settings/rules/index.vue?macro=true";
import { default as indexymmo_MZt5350MhNDrIBdsi1K_zZQvv_452gh9_45d7gdkGwMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/inscription/benevole/index.vue?macro=true";
import { default as add7AzN03Yx5jDNRRHfN6coSH_p_8_c8mUVJuwDJ4B_Xa0Meta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/domaines/add.vue?macro=true";
import { default as addib3guMjMnY_fypOMMdU8eLFa4wusVrpI_Cf61MgAtl8Meta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/taxonomies/[slug]/add.vue?macro=true";
import { default as addI11uR_kARHRkrBbXV5umEFAA26BaeCdU7cCGx9SbFx4Meta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/activites/add.vue?macro=true";
import { default as indexXRR8NcmLV0c4AUgHfqX5mMmbgR0gdsq4PoEGU_45_451JLsMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/reseaux/index.vue?macro=true";
import { default as conversionsf6TmWR93teJfJyqJiFUl6lL6I6XpGqip65hOqmHPFqMMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/statistics/conversions.vue?macro=true";
import { default as editiWq2tHE0glrRlD_VibQlo8AhRQbQpl4UpUCfPGSrZ8UMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/utilisateurs/[id]/edit.vue?macro=true";
import { default as politique_45de_45confidentialite_45aWj8TPWDFVQn2Pm3dq8WAzicecKot6z8Pcr_45qSEBvcMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/politique-de-confidentialite.vue?macro=true";
import { default as indexD_V11QqgO_45m4AJoi3MQmlc2blsIdkZUnz2DlO1vpY0cMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/domaines/index.vue?macro=true";
import { default as add3Yh5T0Q9z9UsoIVi_45iB6brdqQTfnSyfDCtQ6SDWjBrEMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/ressources/add.vue?macro=true";
import { default as benevoles_GUo7g4TzjMW71nc36y8VnpSHWGfTxny41RsoviqqbcMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/missions/[id]/benevoles.vue?macro=true";
import { default as editdAoSnd1BaT4O_45TCclwfX5s8FeXR8zaONTn5Ce0fGKNEMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/organisations/[id]/edit.vue?macro=true";
import { default as utilisateursUyiPrvS61scR41MNHuzKRxVrylrtcYm47F7epu0yikEMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/statistics/utilisateurs.vue?macro=true";
import { default as indexT2gcGpSgmxRXt4rJC6cn_Rvn2fYqdUXkHTHSRSla_t0Meta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/taxonomies/[slug]/index.vue?macro=true";
import { default as index71pbsLz_8wsMhk8dSdPHInwXHbU5Xx1QuKGKNLuT034Meta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/utilisateurs/[id]/index.vue?macro=true";
import { default as indexQ2yt97HaaNZmWp3xk2A_45Les3wFHL1uDcLOJ99_ykJ7AMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/inscription/responsable/index.vue?macro=true";
import { default as indexZiOh3j4TIA3xEl1iBWHlbWtVYb0BmS_45za4owxcIoLNEMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/missions-benevolat/[id]/index.vue?macro=true";
import { default as septembre_45pour_45apprendre3lm0zp6bIF3ikVmlRXdavAx8oQ0EwxxhsSFeIfNo8eoMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/quiz/septembre-pour-apprendre.vue?macro=true";
import { default as indexCdcf1pLUrpemVvKugFYyI8LsYEZSf8AfN9wqD3PakykMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/activites/index.vue?macro=true";
import { default as addWYAUb23l8I9B8FGl_SUkiOP22_yyCdDlPxAuXET_45yFsMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/territoires/add.vue?macro=true";
import { default as indexuBYsTr2b6x8ZN6knpSPhFWNo8Gx8wDJHZdNv_45okpyMUMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/organisations/[id]/index.vue?macro=true";
import { default as editYKHEIlUXeu0_45kGY9FzKkPa4YSFgBEWslY40dmEkua6AMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/settings/rules/[id]/edit.vue?macro=true";
import { default as _91slug_93sIGL_GcKxHA21mV6j5cmC1tsj1ff41jKcMs39AFL2mwMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/missions-benevolat/[id]/[slug].vue?macro=true";
import { default as printemps_45pour_45la_45planeteV3dxvXTxlfzd7oUOELP_pUkA1sCi3bUANoH81O9s_45nwMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/quiz/printemps-pour-la-planete.vue?macro=true";
import { default as index07niPq9JIhXo1QwXhRcU4yV4HBIu7jr82_6DxmV6MwUMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/ressources/index.vue?macro=true";
import { default as participationsuL4xkeMh0SOSd8Q9SQwHDFqHNhMr2XaFRLrqDKQhq24Meta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/statistics/participations.vue?macro=true";
import { default as indexAM88YD_45nRUgxdf3x0TQPy_45_Fn_bVNZIE0vQitM66qTUMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/charte-bon-fonctionnement/index.vue?macro=true";
import { default as activity_45logsFqouhwGebF5AIU6JhySwohTdEYvJxQUYqvnXI4RqJqAMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/support/referents/activity-logs.vue?macro=true";
import { default as editD8a8X_45WdN1lZXC4VjVbHLulZVp7UEbKT__r9mK9Za4QMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/reseaux/[id]/edit.vue?macro=true";
import { default as indexHGkNeo7e9R7Dh4hQwyEs0f_a4KhpTgiiSYGn3ObtFTEMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/territoires/index.vue?macro=true";
import { default as informationsICXxAU5SAD2F7pfEd69ZqDcIkrBJc7n6tBe9EcpdLqUMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/missions/[id]/informations.vue?macro=true";
import { default as responsablesuP_45sDHkeUHtrTNQ5oGi7xXvZY2w_qeu_45XkzRZfSjGscMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/missions/[id]/responsables.vue?macro=true";
import { default as edit1aWK8uZB2Sc1CJqqPCeyG2_2tKJVIbJRAfG05vMRMGAMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/domaines/[id]/edit.vue?macro=true";
import { default as indexdr_JCieo50bz6IIxRLt0fQcEC7zEFq_6z7pS8_45Y_zxwMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/reseaux/[id]/index.vue?macro=true";
import { default as indextRzTbbPExJCEYtY_fSQQaE_45W_45A_R0yFfX_I2FJiHrUwMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/testimonials/index.vue?macro=true";
import { default as indicateurs_45cleszXnoruEgC75MTILuT8wxIDChs0RB5TVS1TlhVei4llkMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/statistics/indicateurs-cles.vue?macro=true";
import { default as editiZ5n6oeg8p30j4jRUAaOrj21mY6ZTfAnpoby59_45bDS0Meta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/taxonomies/[slug]/[id]/edit.vue?macro=true";
import { default as profiletNnS7xWgiITkeyxxRs9pDs_uKC4bjclozH2zFgvyvv0Meta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/inscription/benevole/step/profile.vue?macro=true";
import { default as charte_45bon_45fonctionnementtfveCR9dBDulYFR7eTqy4bp5aN5zPqAdR1gExztguesMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/profile/charte-bon-fonctionnement.vue?macro=true";
import { default as waiting_45actionsuLlAXcwKmGFOxuNgcxg_z4tsseUKZa3wMjEHfcgAPZsMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/support/referents/waiting-actions.vue?macro=true";
import { default as editKRChf4TTL2W8WtqqUw4mHBEx3tbM7za3qCHWUmCnV5sMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/activites/[id]/edit.vue?macro=true";
import { default as addWFXyAoDS8zW0vfu_rq_45hBQYTaKZW_45bkv6S1JauEQb1UMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/modeles-mission/add.vue?macro=true";
import { default as conditions_45generales_45d_45utilisationnJNXn3VQKvj1MmT9hNkPQqj4lAkzfqwulcE9pQBiz24Meta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/conditions-generales-d-utilisation.vue?macro=true";
import { default as index8pDkswIN_45HSQV5_iA1pmmleCBHRDRlWlwJZzeA3E5E8Meta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/activites/[id]/index.vue?macro=true";
import { default as edith1qOZQ_7IokZ2fG02nKKdwn0oIlCGhW4_b8nIoSGt7IMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/ressources/[id]/edit.vue?macro=true";
import { default as diffusionswxYwIkX_DiMBL9qdW5If4LgbDTMepNTGeZv_5K5mgKkMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/organisations/[id]/diffusions.vue?macro=true";
import { default as moderations_454b_45VkFz_hdXXvlkEXL6DSewDe9HzD7ywvqR6Hbt0bUMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/statistics/suivis/moderations.vue?macro=true";
import { default as benevolesfn00SVWUpFtvT8M9ZfO3LMapZLKU8mheJ57l_5onr50Meta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/charte-bon-fonctionnement/benevoles.vue?macro=true";
import { default as google_45api_45indexingQPocM5xW66910U5K1cn3TTnAN9F86emgrBieVyBeRfkMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/support/actions/google-api-indexing.vue?macro=true";
import { default as indexDK5GrbY6iJBWpKIduXZBfZuFlLeCIQblR9MbF8HMkpoMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/modeles-mission/index.vue?macro=true";
import { default as edit30hzv6E8CyE4onO6gVPPH0rzjXWb73QIIhmGrdzIm40Meta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/territoires/[id]/edit.vue?macro=true";
import { default as indexxDCfJkNFf12I3SC1YN95zzbsfxJKuHpQnBpffAZray4Meta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/statistics/organisations/index.vue?macro=true";
import { default as profile4jRcOhkcNyRxE7tFzoLHYXiA0XU3T9Meoujye8jlLasMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/inscription/responsable/step/profile.vue?macro=true";
import { default as indexhBym2Gh4BnNKhBD3Hagwyzucr2KZRrCWvjkxEI_45gs_IMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/territoires/[id]/index.vue?macro=true";
import { default as editO424GoHUljSwuo7wDhzWe1RJUb2AVq4DYTH1Vur_n2MMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/testimonials/[id]/edit.vue?macro=true";
import { default as addz7HGe4khpmEjlli6L8LS7EBOoV_457bkL9NBetldKECZUMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/organisations/[id]/missions/add.vue?macro=true";
import { default as competences5T3a9SLLyQJWcjIjNZDg0SyUpphB3gvpB968IF5gzSoMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/inscription/benevole/step/competences.vue?macro=true";
import { default as preferences6GMGXSXSTvRHT6QGLQZ5jZFm4xuJlkZAq7JTW6bjS8AMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/inscription/benevole/step/preferences.vue?macro=true";
import { default as search_45archived_45usersRJN9gLK7MOALi5sF_45PHYTL2kogyNK5_CFIpKn67deEcMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/support/actions/search-archived-users.vue?macro=true";
import { default as doublons_45territoiresSwjJL5xGZn_w1KqA_qOl7vorLOia66VZYoyfcwHd3DcMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/support/contents/doublons-territoires.vue?macro=true";
import { default as responsablesDPcYv87lYNbcoZKD_45GcfQLnznOuYfrQ0mYrOvuUxNZgMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/charte-bon-fonctionnement/responsables.vue?macro=true";
import { default as transfert_45organisation6F3fN9bqui2kIZTscGEMh0S2ufQIpN4p6noFkjcY4ccMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/support/actions/transfert-organisation.vue?macro=true";
import { default as missions_45outdatedUdm_Sfc48Ml7Eox2vkZ_45H2PlAFXwF4egT50eOpBEvcEMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/support/responsables/missions-outdated.vue?macro=true";
import { default as pending_45items86BXQhHmXDjGXpnkFst50H6wAlaa98HcbKZZ_6R8eZsMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/settings/rules/[id]/pending-items.vue?macro=true";
import { default as user_45reset_45context_45role7Bq_45J_45JK6m3FnaxJruo_X5T6vOuFh_45KfEZuFDINJen8Meta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/support/actions/user-reset-context-role.vue?macro=true";
import { default as doublons_45organisationsk6IIQ_453TQdrUr_45Pu5Ra_45H8DxdXW_450YAaVMlyQ_njZZUMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/support/contents/doublons-organisations.vue?macro=true";
import { default as editlM6pkXea9SXcREVjpG7BK6K8E_qUjz1HMHF1sWhfQkkMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/modeles-mission/[id]/edit.vue?macro=true";
import { default as disponibilitesBo3bC7hT2dhMT8dmEBo6A33nk1zNCJrWrGadgHYG4_gMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/inscription/benevole/step/disponibilites.vue?macro=true";
import { default as user_45reset_45password_45link7banua8xUA9t2c8pBuf_45XpMbeAYg1UxMWsmWvs4ggusMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/support/actions/user-reset-password-link.vue?macro=true";
import { default as indexwluvs2yZ6xMXFipWlxpEXUyuCUxGcH7XfoG1oVlz6zwMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/modeles-mission/[id]/index.vue?macro=true";
import { default as collectiviteNUJTH4IlQaQ6Rm3GDfPGzCshRelJYl8msZihz21KefwMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/inscription/responsable/step/collectivite.vue?macro=true";
import { default as organisation_45aBzBYNWPWyhMmp5qetP_45dF71sm27nFTDWa9FvocMocMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/inscription/responsable/step/organisation.vue?macro=true";
import { default as benevoles_45informationsBiDzq2quJYDKy0HxDbJJ9qI9XFONaDH60zZ67jKbxEIMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/missions/[id]/benevoles-informations.vue?macro=true";
import { default as trafic_45entrantCM5zgZNvhWrEnm0zVl1GXy45sk6NUGGK9lcBqWMcBRUMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/statistics/api-engagement/trafic-entrant.vue?macro=true";
import { default as trafic_45sortantWUpDPfLlh6c0JdA2w8IP9ykCD0qED_45uNJLIrpqimvvcMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/statistics/api-engagement/trafic-sortant.vue?macro=true";
import { default as indexVd4INuRiZimpZE_45_45rKyVLjg7XXQeZmiaH7iGREvP5HgMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/missions/[id]/trouver-des-benevoles/index.vue?macro=true";
import { default as missions_45perimeesh5URevRMZtUrAjyeVxZms1ckOLeX6ibuvnehxe8X_K8Meta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/statistics/departements/missions-perimees.vue?macro=true";
import { default as missions_45a_45validerOWgdRFas98gZhBnZUA1rihAMKc_45pqXqPZqAfcOMhQ_8Meta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/statistics/departements/missions-a-valider.vue?macro=true";
import { default as missions_45perimeesGP3FXwKwAFgEVLgJfepjDPJAxy8sOCa409EQuJV8fT8Meta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/statistics/organisations/missions-perimees.vue?macro=true";
import { default as organisation_45imagesi478wqRqQafvkZAHNVAnWMG1G7y1KU5jvvuuy49i8ggMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/inscription/responsable/step/organisation-images.vue?macro=true";
import { default as organisation_45details_45XquQWqnvtQqOAxVd4BEE_U9OZA3xMjHTfvpR_LppiYMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/inscription/responsable/step/organisation-details.vue?macro=true";
import { default as participations_45to_45be_45treatedsG03Ul3QFt6ypKAcfQ02meB25z__45VeigFNNVIuzQCEUMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/support/responsables/participations-to-be-treated.vue?macro=true";
import { default as redirectGIQqlecdADMVV71ED0qvylxjy21Nq8dtCswsFGUuNxUMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/missions/[id]/trouver-des-benevoles/redirect.vue?macro=true";
import { default as organisations_45a_45valider7ubSawaPc14_VYc_aDw3BIeuBUTOqk_fycmEm5gOWnIMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/statistics/departements/organisations-a-valider.vue?macro=true";
import { default as charte_45bon_45fonctionnement9dAx505Y5KNpzWws8ZJPX7fBFDrL23mTZjtmOFJQ9JwMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/inscription/responsable/step/charte-bon-fonctionnement.vue?macro=true";
import { default as collectivite_45confirmationZG1RiS0Gm2KkiKo0OJ0W6NKqxWwOl1PvCO4HtCLyhsIMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/inscription/responsable/step/collectivite-confirmation.vue?macro=true";
import { default as organisation_45confirmationbr9gntZQ2d84cDWoTJWvlgktPnz0aJmTfunJSdJGnKQMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/inscription/responsable/step/organisation-confirmation.vue?macro=true";
import { default as participations_45a_45validerCoQPqFOyzBGChT0kgq1rcn9Vftin7Fwxjlob26b5s_MMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/statistics/organisations/participations-a-valider.vue?macro=true";
import { default as participations_45refusees_45annuleesPVjsjs5_45Kvg_2ezZUOYKPE7NLRIVCm8MinPnKnH9fXAMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/statistics/organisations/participations-refusees-annulees.vue?macro=true";
import { default as component_45stub7ik1APMsya2rcL6_45udiv1E8Ly4tBlYllsRrv897IzsQMeta } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub7ik1APMsya2rcL6_45udiv1E8Ly4tBlYllsRrv897IzsQ } from "/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginjqJg3PVgpmzxLQXzQhjB5T82owLgVI0QahJnMVOm4osMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/login.vue")
  },
  {
    name: "s-key",
    path: "/s/:key()",
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/s/[key].vue")
  },
  {
    name: "quiz-mgen",
    path: "/quiz/mgen",
    meta: mgen_45tD6_45QL0y6JDUtWCOuyRck_45JaXlOTJ9NbfFVZCRosZAMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/quiz/mgen.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: indexmljeiYF4LkE3y_45OLOJddKQfqycLvR4wx_45BBlE_45pFv5AMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/index.vue")
  },
  {
    name: "admin-notes",
    path: "/admin/notes",
    meta: notesm7IOFz6FkF_45XbOG8HKMJ4O4e5Psi95j_455NtL_45Prxp7gMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/notes.vue")
  },
  {
    name: "stats",
    path: "/stats",
    meta: indexljHERAKvn5s0UkC4GBozySRQZtFXL3CGO4Md0fbB_45yAMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/stats/index.vue")
  },
  {
    name: "en-ce-moment",
    path: "/en-ce-moment",
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/en-ce-moment.vue")
  },
  {
    name: "plan-du-site",
    path: "/plan-du-site",
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/plan-du-site.vue")
  },
  {
    name: "profile-edit",
    path: "/profile/edit",
    meta: editbU8ldTkmLonnoYH8M6T18mqQOqigKBqMsLkAYMswyQQMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/profile/edit.vue")
  },
  {
    name: "stats-places",
    path: "/stats/places",
    meta: places6alDxoC5GM76bTOOLVUhfkcyK_ViqoL4ABV9_yp_45isIMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/stats/places.vue")
  },
  {
    name: "accessibilite",
    path: "/accessibilite",
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/accessibilite.vue")
  },
  {
    name: "messages-id",
    path: "/messages/:id()",
    meta: _91id_93BWZP5K8t_456M1eYX1RDva_fJdjm2yKlXXJsr8LoA9JLsMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/messages/[id].vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    meta: notificationsAfuVPC391OKa0hBIkPolLCK9OkCveyrUDmuV7QANJikMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/notifications.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: indexkOX3eEsAvwlulVChMacvEuEcft5DJvlZTSsiheD5PgcMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/profile/index.vue")
  },
  {
    name: "support",
    path: "/support",
    meta: index_WqIziwfjDPyGuZVF34_45ikfxaVlSnX9oIKdwpvCtxuUMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/support/index.vue")
  },
  {
    name: "villes-slug",
    path: "/villes/:slug()",
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/villes/[slug].vue")
  },
  {
    name: "messages",
    path: "/messages",
    meta: indexKtTM9Q5_45GyYQfWX_iYRI6a_eymnIyOKEgybyvRz2NtIMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/messages/index.vue")
  },
  {
    name: "quiz-generique",
    path: "/quiz/generique",
    meta: generique9Qv6SUIS0uutCsNTEBB5eEbJEpwrdqqibDokytBNmuIMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/quiz/generique.vue")
  },
  {
    name: "reseaux-slug",
    path: "/reseaux/:slug()",
    meta: _91slug_93iWGrA0ezCoVYbN2BDyrrtR6L3fQeWMGNzS0sSkL2Qt4Meta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/reseaux/[slug].vue")
  },
  {
    name: "stats-missions",
    path: "/stats/missions",
    meta: missionsBaG70HbNjP2ohRDlLy_4552dLiqqv7xFoBohC6q_uF1qIMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/stats/missions.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: indexacYmiii7KwDSlN88SNi1PAygxOLnDTeEHJpY4b4GHIcMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/dashboard/index.vue")
  },
  {
    name: "profile-favoris",
    path: "/profile/favoris",
    meta: favorisLXfUjDN6TdnYXcKkJXOyEjwTrjvdXCBwTvOX0vSWz9gMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/profile/favoris.vue")
  },
  {
    name: "activites-slug",
    path: "/activites/:slug()",
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/activites/[slug].vue")
  },
  {
    name: "admin-other-logs",
    path: "/admin/other/logs",
    meta: logsQ_3nVudBWbqg2p_45Pqt8BpOfJHvIaPeyQgMcKU2tm5ZsMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/other/logs.vue")
  },
  {
    name: "admin-ressources",
    path: "/admin/ressources",
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/ressources.vue")
  },
  {
    name: "mentions-legales",
    path: "/mentions-legales",
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/mentions-legales.vue")
  },
  {
    name: "profile-missions",
    path: "/profile/missions",
    meta: missionssMvvCAzij3_uNKi8X5MN8jWkK9mjzyK13_kzEK_45EU5IMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/profile/missions.vue")
  },
  {
    name: "profile-settings",
    path: "/profile/settings",
    meta: settingsj8LQqT3YzoeXTyQ3CPRIU_45xAKkNus7vYtoGnAJWPjuYMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/profile/settings.vue")
  },
  {
    name: "quiz-tournee-ete",
    path: "/quiz/tournee-ete",
    meta: tournee_45ete_HeXGRbfq3HN_45vwYb59IBAeplUXzQ4xPCOcxhgA3RUMMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/quiz/tournee-ete.vue")
  },
  {
    name: "admin-temoignages",
    path: "/admin/temoignages",
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/temoignages.vue")
  },
  {
    name: "inscription",
    path: "/inscription",
    meta: indexRQcze9Z1qbaSinA_45dqAqiT3qmWKCD_v5qeaVOsAVcYwMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/inscription/index.vue")
  },
  {
    name: "maintenance-admin",
    path: "/maintenance/admin",
    meta: adminOSwXuneV7zlo_45CqgPcHliiKr1uOiXkVOZrGG_vMwHQEMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/maintenance/admin.vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    meta: indexmKM1SSE27SU_2KcL9R150NPFVJlqwHWWqa61zkfdChgMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/maintenance/index.vue")
  },
  {
    name: "territoires",
    path: "/territoires",
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/territoires/index.vue")
  },
  {
    name: "invitations-hash",
    path: "/invitations/:hash()",
    meta: _91hash_93NW49Lq81JRjqz3kghCgo_45hJVTULbXEfiUOb99HO1h8MMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/invitations/[hash].vue")
  },
  {
    name: "stats-utilisateurs",
    path: "/stats/utilisateurs",
    meta: utilisateursDUDxCu11J4hXgt4oF_yTlDTLPHauUsDjlP6Wt_WVzvQMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/stats/utilisateurs.vue")
  },
  {
    name: "associations-slug",
    path: "/associations/:slug()",
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/associations/[slug].vue")
  },
  {
    name: "departements-slug",
    path: "/departements/:slug()",
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/departements/[slug].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/organisations/index.vue")
  },
  {
    name: "profile-preferences",
    path: "/profile/preferences",
    meta: preferencesZLpVz2Rl5KXRs8iEPFc_BsPZXd1bWpp1J1zI7G38wf8Meta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/profile/preferences.vue")
  },
  {
    name: "stats-organisations",
    path: "/stats/organisations",
    meta: organisations1LmNXpl5pf1AAHkyE09qx_45Fu0avJhR8kcHKWVgxadu8Meta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/stats/organisations.vue")
  },
  {
    name: "temoignages-token",
    path: "/temoignages/:token()",
    meta: _91token_93jJnGtecWo3URsWCsp7JR03W88m2t7Wvewu1JANFqlaAMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/temoignages/[token].vue")
  },
  {
    name: "admin-contenus-posts",
    path: "/admin/contenus/posts",
    meta: postsUPWSALmYB9anWbOAMvNluIvtfx_45hN9LjJUaZKZYg55wMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/posts.vue")
  },
  {
    name: "admin-missions",
    path: "/admin/missions",
    meta: indexFsxOmCg3ZBe7q3w9ZZv9oV_UmVnyERSR4mayGaBRfVgMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/missions/index.vue")
  },
  {
    name: "messages-modeles-add",
    path: "/messages/modeles/add",
    meta: addQZ3vOePGwTWdPBkJKaUZyH0HrHMt1oU_7ABrdFhr3PIMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/messages/modeles/add.vue")
  },
  {
    name: "organisations-slug",
    path: "/organisations/:slug()",
    meta: _91slug_934RThx_PBTlXJ9E5UvzXwv_45lUyPPez8B9F0vFN_SUC_458Meta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/organisations/[slug].vue")
  },
  {
    name: "password-reset",
    path: "/password-reset",
    meta: indexERU3PdviWR3urA2mzwgj0AGGXJ0VTqFtV7JctDYtmFoMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/password-reset/index.vue")
  },
  {
    name: "stats-participations",
    path: "/stats/participations",
    meta: participations5rMJFKjkNBt9Vh_45mshmGXt9ylFn0WwMcf_454mlCRdB_AMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/stats/participations.vue")
  },
  {
    name: "admin-settings-emails",
    path: "/admin/settings/emails",
    meta: emailsUu36TAU3T6FLEz8sAfLkfL5BkvlDGoQwu5CXiaS5h1EMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/settings/emails.vue")
  },
  {
    name: "profile-alertes",
    path: "/profile/alertes",
    meta: indexNT3J9gR0NUhnTaC1EZzPMjBkrSd0EemvHXBzX6HTTqgMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/profile/alertes/index.vue")
  },
  {
    name: "profile-notifications",
    path: "/profile/notifications",
    meta: notifications0eq_IP0orF3BsTFdU8mvsgOoJeB8htrfbj7005rZ7U0Meta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/profile/notifications.vue")
  },
  {
    name: "admin-statistics",
    path: "/admin/statistics",
    meta: index8yUCSS4ZXIRF_45hk_rlUwQxPePkF3lfMQ9HA8CVhGS9YMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/statistics/index.vue")
  },
  {
    name: "charte-reserve-civique",
    path: "/charte-reserve-civique",
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/charte-reserve-civique.vue")
  },
  {
    name: "domaines-action-slug",
    path: "/domaines-action/:slug()",
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/domaines-action/[slug].vue")
  },
  {
    name: "messages-modeles",
    path: "/messages/modeles",
    meta: indexdh1AM_45Z_45DhGIgGJZ9UDBD7lQzscCiCZlcaJago4wXE8Meta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/messages/modeles/index.vue")
  },
  {
    name: "password-reset-token",
    path: "/password-reset/:token()",
    meta: _91token_93djXeIG8zgLoYRX4ddUq_OqY3VNb71UergcxQL2uqwNgMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/password-reset/[token].vue")
  },
  {
    name: "quiz-decembre-ensemble",
    path: "/quiz/decembre-ensemble",
    meta: decembre_45ensembleZ7vnptWTKFL6h5Bhk3YWfYtSj287JqFgJhlYTijQVA0Meta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/quiz/decembre-ensemble.vue")
  },
  {
    name: "admin-other-invitations",
    path: "/admin/other/invitations",
    meta: invitationso9_45BppS28RgVWnad4QXHr8hPaOr7ak_6jjA57JAS2XsMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/other/invitations.vue")
  },
  {
    name: "admin-settings-messages",
    path: "/admin/settings/messages",
    meta: messagesb1_45Xfk_45Yx2g_P4M18FUt12juXWGMPxN6xcZB98jqNAUMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/settings/messages.vue")
  },
  {
    name: "admin-statistics-places",
    path: "/admin/statistics/places",
    meta: placesMdlsxNPfOimELx2HO6N2Bk6AzmQNBxGkpUMxb7p7BBIMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/statistics/places.vue")
  },
  {
    name: "admin-settings-rules-add",
    path: "/admin/settings/rules/add",
    meta: addNgqCjN9LqgQxtbpPjCAKN4ReCAnPZGKRPKn5QfOZnlUMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/settings/rules/add.vue")
  },
  {
    name: "admin-utilisateurs",
    path: "/admin/utilisateurs",
    meta: index60JvTYwcQB_45oMMgV2fltF_vaogwxerV_SIWJMZBQh9kMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/utilisateurs/index.vue")
  },
  {
    name: "missions-benevolat",
    path: "/missions-benevolat",
    meta: indexjgzcFC0kHjV_1UGTBuGr7rJoAqDEy0l45yow56hovGcMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/missions-benevolat/index.vue")
  },
  {
    name: "admin-missions-id-dates",
    path: "/admin/missions/:id()/dates",
    meta: datesEkmJdDo5hAee_nmxGmun2IcMVmyE_45iSINkI6wrptOkgMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/missions/[id]/dates.vue")
  },
  {
    name: "admin-missions-id",
    path: "/admin/missions/:id()",
    meta: indexQlfzwdAl7p_45B2JApbQysQ0zU0bC29FesStZhDamZUesMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/missions/[id]/index.vue")
  },
  {
    name: "admin-missions-id-lieux",
    path: "/admin/missions/:id()/lieux",
    meta: lieuxxYLvPrGnVXDGmlclkisaljQpmHopNntbneDkOxEDMb4Meta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/missions/[id]/lieux.vue")
  },
  {
    name: "admin-missions-id-title",
    path: "/admin/missions/:id()/title",
    meta: titlet6ALlztB0SG0wKgIn6fp3vaQE5IcLIAWC1rP2iQWg0QMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/missions/[id]/title.vue")
  },
  {
    name: "admin-organisations",
    path: "/admin/organisations",
    meta: index240d0dlKDwnGFJtNQA8gDuE7XZLX8crFHRJuno5xO3IMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/organisations/index.vue")
  },
  {
    name: "admin-statistics-missions",
    path: "/admin/statistics/missions",
    meta: missionsuhmBVI9v3ObhxuIneDGlXr_45BrvqbqlsnHonITfMumSgMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/statistics/missions.vue")
  },
  {
    name: "admin-contenus-reseaux-add",
    path: "/admin/contenus/reseaux/add",
    meta: addJo_uaH0Z41n22ZpVaHsBc1GF0P2QL0okLQYqosKSogQMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/reseaux/add.vue")
  },
  {
    name: "admin-missions-id-visuel",
    path: "/admin/missions/:id()/visuel",
    meta: visueld4bRFDYNXET3nJDY5jzpK5VFuMLb2PrDExxDqbDCbpAMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/missions/[id]/visuel.vue")
  },
  {
    name: "admin-participations",
    path: "/admin/participations",
    meta: indexuPbMeT_45qvM3mZZVLkdc84N8WKeesYaMckocHq8yDywUMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/participations/index.vue")
  },
  {
    name: "admin-settings-rules",
    path: "/admin/settings/rules",
    meta: indexdFvDYhYCMlK8h0RYfz4XIu4ka9ZaqvIov7CwWB0_45HFMMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/settings/rules/index.vue")
  },
  {
    name: "inscription-benevole",
    path: "/inscription/benevole",
    meta: indexymmo_MZt5350MhNDrIBdsi1K_zZQvv_452gh9_45d7gdkGwMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/inscription/benevole/index.vue")
  },
  {
    name: "admin-contenus-domaines-add",
    path: "/admin/contenus/domaines/add",
    meta: add7AzN03Yx5jDNRRHfN6coSH_p_8_c8mUVJuwDJ4B_Xa0Meta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/domaines/add.vue")
  },
  {
    name: "admin-taxonomies-slug-add",
    path: "/admin/taxonomies/:slug()/add",
    meta: addib3guMjMnY_fypOMMdU8eLFa4wusVrpI_Cf61MgAtl8Meta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/taxonomies/[slug]/add.vue")
  },
  {
    name: "admin-contenus-activites-add",
    path: "/admin/contenus/activites/add",
    meta: addI11uR_kARHRkrBbXV5umEFAA26BaeCdU7cCGx9SbFx4Meta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/activites/add.vue")
  },
  {
    name: "admin-contenus-reseaux",
    path: "/admin/contenus/reseaux",
    meta: indexXRR8NcmLV0c4AUgHfqX5mMmbgR0gdsq4PoEGU_45_451JLsMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/reseaux/index.vue")
  },
  {
    name: "admin-statistics-conversions",
    path: "/admin/statistics/conversions",
    meta: conversionsf6TmWR93teJfJyqJiFUl6lL6I6XpGqip65hOqmHPFqMMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/statistics/conversions.vue")
  },
  {
    name: "admin-utilisateurs-id-edit",
    path: "/admin/utilisateurs/:id()/edit",
    meta: editiWq2tHE0glrRlD_VibQlo8AhRQbQpl4UpUCfPGSrZ8UMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/utilisateurs/[id]/edit.vue")
  },
  {
    name: "politique-de-confidentialite",
    path: "/politique-de-confidentialite",
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/politique-de-confidentialite.vue")
  },
  {
    name: "admin-contenus-domaines",
    path: "/admin/contenus/domaines",
    meta: indexD_V11QqgO_45m4AJoi3MQmlc2blsIdkZUnz2DlO1vpY0cMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/domaines/index.vue")
  },
  {
    name: "admin-contenus-ressources-add",
    path: "/admin/contenus/ressources/add",
    meta: add3Yh5T0Q9z9UsoIVi_45iB6brdqQTfnSyfDCtQ6SDWjBrEMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/ressources/add.vue")
  },
  {
    name: "admin-missions-id-benevoles",
    path: "/admin/missions/:id()/benevoles",
    meta: benevoles_GUo7g4TzjMW71nc36y8VnpSHWGfTxny41RsoviqqbcMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/missions/[id]/benevoles.vue")
  },
  {
    name: "admin-organisations-id-edit",
    path: "/admin/organisations/:id()/edit",
    meta: editdAoSnd1BaT4O_45TCclwfX5s8FeXR8zaONTn5Ce0fGKNEMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/organisations/[id]/edit.vue")
  },
  {
    name: "admin-statistics-utilisateurs",
    path: "/admin/statistics/utilisateurs",
    meta: utilisateursUyiPrvS61scR41MNHuzKRxVrylrtcYm47F7epu0yikEMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/statistics/utilisateurs.vue")
  },
  {
    name: "admin-taxonomies-slug",
    path: "/admin/taxonomies/:slug()",
    meta: indexT2gcGpSgmxRXt4rJC6cn_Rvn2fYqdUXkHTHSRSla_t0Meta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/taxonomies/[slug]/index.vue")
  },
  {
    name: "admin-utilisateurs-id",
    path: "/admin/utilisateurs/:id()",
    meta: index71pbsLz_8wsMhk8dSdPHInwXHbU5Xx1QuKGKNLuT034Meta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/utilisateurs/[id]/index.vue")
  },
  {
    name: "inscription-responsable",
    path: "/inscription/responsable",
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/inscription/responsable/index.vue")
  },
  {
    name: "missions-benevolat-id",
    path: "/missions-benevolat/:id()",
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/missions-benevolat/[id]/index.vue")
  },
  {
    name: "quiz-septembre-pour-apprendre",
    path: "/quiz/septembre-pour-apprendre",
    meta: septembre_45pour_45apprendre3lm0zp6bIF3ikVmlRXdavAx8oQ0EwxxhsSFeIfNo8eoMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/quiz/septembre-pour-apprendre.vue")
  },
  {
    name: "admin-contenus-activites",
    path: "/admin/contenus/activites",
    meta: indexCdcf1pLUrpemVvKugFYyI8LsYEZSf8AfN9wqD3PakykMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/activites/index.vue")
  },
  {
    name: "admin-contenus-territoires-add",
    path: "/admin/contenus/territoires/add",
    meta: addWYAUb23l8I9B8FGl_SUkiOP22_yyCdDlPxAuXET_45yFsMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/territoires/add.vue")
  },
  {
    name: "admin-organisations-id",
    path: "/admin/organisations/:id()",
    meta: indexuBYsTr2b6x8ZN6knpSPhFWNo8Gx8wDJHZdNv_45okpyMUMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/organisations/[id]/index.vue")
  },
  {
    name: "admin-settings-rules-id-edit",
    path: "/admin/settings/rules/:id()/edit",
    meta: editYKHEIlUXeu0_45kGY9FzKkPa4YSFgBEWslY40dmEkua6AMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/settings/rules/[id]/edit.vue")
  },
  {
    name: "missions-benevolat-id-slug",
    path: "/missions-benevolat/:id()/:slug()",
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/missions-benevolat/[id]/[slug].vue")
  },
  {
    name: "quiz-printemps-pour-la-planete",
    path: "/quiz/printemps-pour-la-planete",
    meta: printemps_45pour_45la_45planeteV3dxvXTxlfzd7oUOELP_pUkA1sCi3bUANoH81O9s_45nwMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/quiz/printemps-pour-la-planete.vue")
  },
  {
    name: "admin-contenus-ressources",
    path: "/admin/contenus/ressources",
    meta: index07niPq9JIhXo1QwXhRcU4yV4HBIu7jr82_6DxmV6MwUMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/ressources/index.vue")
  },
  {
    name: "admin-statistics-participations",
    path: "/admin/statistics/participations",
    meta: participationsuL4xkeMh0SOSd8Q9SQwHDFqHNhMr2XaFRLrqDKQhq24Meta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/statistics/participations.vue")
  },
  {
    name: "charte-bon-fonctionnement",
    path: "/charte-bon-fonctionnement",
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/charte-bon-fonctionnement/index.vue")
  },
  {
    name: "support-referents-activity-logs",
    path: "/support/referents/activity-logs",
    meta: activity_45logsFqouhwGebF5AIU6JhySwohTdEYvJxQUYqvnXI4RqJqAMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/support/referents/activity-logs.vue")
  },
  {
    name: "admin-contenus-reseaux-id-edit",
    path: "/admin/contenus/reseaux/:id()/edit",
    meta: editD8a8X_45WdN1lZXC4VjVbHLulZVp7UEbKT__r9mK9Za4QMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/reseaux/[id]/edit.vue")
  },
  {
    name: "admin-contenus-territoires",
    path: "/admin/contenus/territoires",
    meta: indexHGkNeo7e9R7Dh4hQwyEs0f_a4KhpTgiiSYGn3ObtFTEMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/territoires/index.vue")
  },
  {
    name: "admin-missions-id-informations",
    path: "/admin/missions/:id()/informations",
    meta: informationsICXxAU5SAD2F7pfEd69ZqDcIkrBJc7n6tBe9EcpdLqUMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/missions/[id]/informations.vue")
  },
  {
    name: "admin-missions-id-responsables",
    path: "/admin/missions/:id()/responsables",
    meta: responsablesuP_45sDHkeUHtrTNQ5oGi7xXvZY2w_qeu_45XkzRZfSjGscMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/missions/[id]/responsables.vue")
  },
  {
    name: "admin-contenus-domaines-id-edit",
    path: "/admin/contenus/domaines/:id()/edit",
    meta: edit1aWK8uZB2Sc1CJqqPCeyG2_2tKJVIbJRAfG05vMRMGAMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/domaines/[id]/edit.vue")
  },
  {
    name: "admin-contenus-reseaux-id",
    path: "/admin/contenus/reseaux/:id()",
    meta: indexdr_JCieo50bz6IIxRLt0fQcEC7zEFq_6z7pS8_45Y_zxwMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/reseaux/[id]/index.vue")
  },
  {
    name: "admin-contenus-testimonials",
    path: "/admin/contenus/testimonials",
    meta: indextRzTbbPExJCEYtY_fSQQaE_45W_45A_R0yFfX_I2FJiHrUwMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/testimonials/index.vue")
  },
  {
    name: "admin-statistics-indicateurs-cles",
    path: "/admin/statistics/indicateurs-cles",
    meta: indicateurs_45cleszXnoruEgC75MTILuT8wxIDChs0RB5TVS1TlhVei4llkMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/statistics/indicateurs-cles.vue")
  },
  {
    name: "admin-taxonomies-slug-id-edit",
    path: "/admin/taxonomies/:slug()/:id()/edit",
    meta: editiZ5n6oeg8p30j4jRUAaOrj21mY6ZTfAnpoby59_45bDS0Meta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/taxonomies/[slug]/[id]/edit.vue")
  },
  {
    name: "inscription-benevole-step-profile",
    path: "/inscription/benevole/step/profile",
    meta: profiletNnS7xWgiITkeyxxRs9pDs_uKC4bjclozH2zFgvyvv0Meta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/inscription/benevole/step/profile.vue")
  },
  {
    name: "profile-charte-bon-fonctionnement",
    path: "/profile/charte-bon-fonctionnement",
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/profile/charte-bon-fonctionnement.vue")
  },
  {
    name: "support-referents-waiting-actions",
    path: "/support/referents/waiting-actions",
    meta: waiting_45actionsuLlAXcwKmGFOxuNgcxg_z4tsseUKZa3wMjEHfcgAPZsMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/support/referents/waiting-actions.vue")
  },
  {
    name: "admin-contenus-activites-id-edit",
    path: "/admin/contenus/activites/:id()/edit",
    meta: editKRChf4TTL2W8WtqqUw4mHBEx3tbM7za3qCHWUmCnV5sMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/activites/[id]/edit.vue")
  },
  {
    name: "admin-contenus-modeles-mission-add",
    path: "/admin/contenus/modeles-mission/add",
    meta: addWFXyAoDS8zW0vfu_rq_45hBQYTaKZW_45bkv6S1JauEQb1UMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/modeles-mission/add.vue")
  },
  {
    name: "conditions-generales-d-utilisation",
    path: "/conditions-generales-d-utilisation",
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/conditions-generales-d-utilisation.vue")
  },
  {
    name: "admin-contenus-activites-id",
    path: "/admin/contenus/activites/:id()",
    meta: index8pDkswIN_45HSQV5_iA1pmmleCBHRDRlWlwJZzeA3E5E8Meta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/activites/[id]/index.vue")
  },
  {
    name: "admin-contenus-ressources-id-edit",
    path: "/admin/contenus/ressources/:id()/edit",
    meta: edith1qOZQ_7IokZ2fG02nKKdwn0oIlCGhW4_b8nIoSGt7IMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/ressources/[id]/edit.vue")
  },
  {
    name: "admin-organisations-id-diffusions",
    path: "/admin/organisations/:id()/diffusions",
    meta: diffusionswxYwIkX_DiMBL9qdW5If4LgbDTMepNTGeZv_5K5mgKkMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/organisations/[id]/diffusions.vue")
  },
  {
    name: "admin-statistics-suivis-moderations",
    path: "/admin/statistics/suivis/moderations",
    meta: moderations_454b_45VkFz_hdXXvlkEXL6DSewDe9HzD7ywvqR6Hbt0bUMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/statistics/suivis/moderations.vue")
  },
  {
    name: "charte-bon-fonctionnement-benevoles",
    path: "/charte-bon-fonctionnement/benevoles",
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/charte-bon-fonctionnement/benevoles.vue")
  },
  {
    name: "support-actions-google-api-indexing",
    path: "/support/actions/google-api-indexing",
    meta: google_45api_45indexingQPocM5xW66910U5K1cn3TTnAN9F86emgrBieVyBeRfkMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/support/actions/google-api-indexing.vue")
  },
  {
    name: "admin-contenus-modeles-mission",
    path: "/admin/contenus/modeles-mission",
    meta: indexDK5GrbY6iJBWpKIduXZBfZuFlLeCIQblR9MbF8HMkpoMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/modeles-mission/index.vue")
  },
  {
    name: "admin-contenus-territoires-id-edit",
    path: "/admin/contenus/territoires/:id()/edit",
    meta: edit30hzv6E8CyE4onO6gVPPH0rzjXWb73QIIhmGrdzIm40Meta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/territoires/[id]/edit.vue")
  },
  {
    name: "admin-statistics-organisations",
    path: "/admin/statistics/organisations",
    meta: indexxDCfJkNFf12I3SC1YN95zzbsfxJKuHpQnBpffAZray4Meta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/statistics/organisations/index.vue")
  },
  {
    name: "inscription-responsable-step-profile",
    path: "/inscription/responsable/step/profile",
    meta: profile4jRcOhkcNyRxE7tFzoLHYXiA0XU3T9Meoujye8jlLasMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/inscription/responsable/step/profile.vue")
  },
  {
    name: "admin-contenus-territoires-id",
    path: "/admin/contenus/territoires/:id()",
    meta: indexhBym2Gh4BnNKhBD3Hagwyzucr2KZRrCWvjkxEI_45gs_IMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/territoires/[id]/index.vue")
  },
  {
    name: "admin-contenus-testimonials-id-edit",
    path: "/admin/contenus/testimonials/:id()/edit",
    meta: editO424GoHUljSwuo7wDhzWe1RJUb2AVq4DYTH1Vur_n2MMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/testimonials/[id]/edit.vue")
  },
  {
    name: "admin-organisations-id-missions-add",
    path: "/admin/organisations/:id()/missions/add",
    meta: addz7HGe4khpmEjlli6L8LS7EBOoV_457bkL9NBetldKECZUMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/organisations/[id]/missions/add.vue")
  },
  {
    name: "inscription-benevole-step-competences",
    path: "/inscription/benevole/step/competences",
    meta: competences5T3a9SLLyQJWcjIjNZDg0SyUpphB3gvpB968IF5gzSoMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/inscription/benevole/step/competences.vue")
  },
  {
    name: "inscription-benevole-step-preferences",
    path: "/inscription/benevole/step/preferences",
    meta: preferences6GMGXSXSTvRHT6QGLQZ5jZFm4xuJlkZAq7JTW6bjS8AMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/inscription/benevole/step/preferences.vue")
  },
  {
    name: "support-actions-search-archived-users",
    path: "/support/actions/search-archived-users",
    meta: search_45archived_45usersRJN9gLK7MOALi5sF_45PHYTL2kogyNK5_CFIpKn67deEcMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/support/actions/search-archived-users.vue")
  },
  {
    name: "support-contents-doublons-territoires",
    path: "/support/contents/doublons-territoires",
    meta: doublons_45territoiresSwjJL5xGZn_w1KqA_qOl7vorLOia66VZYoyfcwHd3DcMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/support/contents/doublons-territoires.vue")
  },
  {
    name: "charte-bon-fonctionnement-responsables",
    path: "/charte-bon-fonctionnement/responsables",
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/charte-bon-fonctionnement/responsables.vue")
  },
  {
    name: "support-actions-transfert-organisation",
    path: "/support/actions/transfert-organisation",
    meta: transfert_45organisation6F3fN9bqui2kIZTscGEMh0S2ufQIpN4p6noFkjcY4ccMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/support/actions/transfert-organisation.vue")
  },
  {
    name: "support-responsables-missions-outdated",
    path: "/support/responsables/missions-outdated",
    meta: missions_45outdatedUdm_Sfc48Ml7Eox2vkZ_45H2PlAFXwF4egT50eOpBEvcEMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/support/responsables/missions-outdated.vue")
  },
  {
    name: "admin-settings-rules-id-pending-items",
    path: "/admin/settings/rules/:id()/pending-items",
    meta: pending_45items86BXQhHmXDjGXpnkFst50H6wAlaa98HcbKZZ_6R8eZsMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/settings/rules/[id]/pending-items.vue")
  },
  {
    name: "support-actions-user-reset-context-role",
    path: "/support/actions/user-reset-context-role",
    meta: user_45reset_45context_45role7Bq_45J_45JK6m3FnaxJruo_X5T6vOuFh_45KfEZuFDINJen8Meta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/support/actions/user-reset-context-role.vue")
  },
  {
    name: "support-contents-doublons-organisations",
    path: "/support/contents/doublons-organisations",
    meta: doublons_45organisationsk6IIQ_453TQdrUr_45Pu5Ra_45H8DxdXW_450YAaVMlyQ_njZZUMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/support/contents/doublons-organisations.vue")
  },
  {
    name: "admin-contenus-modeles-mission-id-edit",
    path: "/admin/contenus/modeles-mission/:id()/edit",
    meta: editlM6pkXea9SXcREVjpG7BK6K8E_qUjz1HMHF1sWhfQkkMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/modeles-mission/[id]/edit.vue")
  },
  {
    name: "inscription-benevole-step-disponibilites",
    path: "/inscription/benevole/step/disponibilites",
    meta: disponibilitesBo3bC7hT2dhMT8dmEBo6A33nk1zNCJrWrGadgHYG4_gMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/inscription/benevole/step/disponibilites.vue")
  },
  {
    name: "support-actions-user-reset-password-link",
    path: "/support/actions/user-reset-password-link",
    meta: user_45reset_45password_45link7banua8xUA9t2c8pBuf_45XpMbeAYg1UxMWsmWvs4ggusMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/support/actions/user-reset-password-link.vue")
  },
  {
    name: "admin-contenus-modeles-mission-id",
    path: "/admin/contenus/modeles-mission/:id()",
    meta: indexwluvs2yZ6xMXFipWlxpEXUyuCUxGcH7XfoG1oVlz6zwMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/contenus/modeles-mission/[id]/index.vue")
  },
  {
    name: "inscription-responsable-step-collectivite",
    path: "/inscription/responsable/step/collectivite",
    meta: collectiviteNUJTH4IlQaQ6Rm3GDfPGzCshRelJYl8msZihz21KefwMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/inscription/responsable/step/collectivite.vue")
  },
  {
    name: "inscription-responsable-step-organisation",
    path: "/inscription/responsable/step/organisation",
    meta: organisation_45aBzBYNWPWyhMmp5qetP_45dF71sm27nFTDWa9FvocMocMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/inscription/responsable/step/organisation.vue")
  },
  {
    name: "admin-missions-id-benevoles-informations",
    path: "/admin/missions/:id()/benevoles-informations",
    meta: benevoles_45informationsBiDzq2quJYDKy0HxDbJJ9qI9XFONaDH60zZ67jKbxEIMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/missions/[id]/benevoles-informations.vue")
  },
  {
    name: "admin-statistics-api-engagement-trafic-entrant",
    path: "/admin/statistics/api-engagement/trafic-entrant",
    meta: trafic_45entrantCM5zgZNvhWrEnm0zVl1GXy45sk6NUGGK9lcBqWMcBRUMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/statistics/api-engagement/trafic-entrant.vue")
  },
  {
    name: "admin-statistics-api-engagement-trafic-sortant",
    path: "/admin/statistics/api-engagement/trafic-sortant",
    meta: trafic_45sortantWUpDPfLlh6c0JdA2w8IP9ykCD0qED_45uNJLIrpqimvvcMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/statistics/api-engagement/trafic-sortant.vue")
  },
  {
    name: "admin-missions-id-trouver-des-benevoles",
    path: "/admin/missions/:id()/trouver-des-benevoles",
    meta: indexVd4INuRiZimpZE_45_45rKyVLjg7XXQeZmiaH7iGREvP5HgMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/missions/[id]/trouver-des-benevoles/index.vue")
  },
  {
    name: "admin-statistics-departements-missions-perimees",
    path: "/admin/statistics/departements/missions-perimees",
    meta: missions_45perimeesh5URevRMZtUrAjyeVxZms1ckOLeX6ibuvnehxe8X_K8Meta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/statistics/departements/missions-perimees.vue")
  },
  {
    name: "admin-statistics-departements-missions-a-valider",
    path: "/admin/statistics/departements/missions-a-valider",
    meta: missions_45a_45validerOWgdRFas98gZhBnZUA1rihAMKc_45pqXqPZqAfcOMhQ_8Meta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/statistics/departements/missions-a-valider.vue")
  },
  {
    name: "admin-statistics-organisations-missions-perimees",
    path: "/admin/statistics/organisations/missions-perimees",
    meta: missions_45perimeesGP3FXwKwAFgEVLgJfepjDPJAxy8sOCa409EQuJV8fT8Meta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/statistics/organisations/missions-perimees.vue")
  },
  {
    name: "inscription-responsable-step-organisation-images",
    path: "/inscription/responsable/step/organisation-images",
    meta: organisation_45imagesi478wqRqQafvkZAHNVAnWMG1G7y1KU5jvvuuy49i8ggMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/inscription/responsable/step/organisation-images.vue")
  },
  {
    name: "inscription-responsable-step-organisation-details",
    path: "/inscription/responsable/step/organisation-details",
    meta: organisation_45details_45XquQWqnvtQqOAxVd4BEE_U9OZA3xMjHTfvpR_LppiYMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/inscription/responsable/step/organisation-details.vue")
  },
  {
    name: "support-responsables-participations-to-be-treated",
    path: "/support/responsables/participations-to-be-treated",
    meta: participations_45to_45be_45treatedsG03Ul3QFt6ypKAcfQ02meB25z__45VeigFNNVIuzQCEUMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/support/responsables/participations-to-be-treated.vue")
  },
  {
    name: "admin-missions-id-trouver-des-benevoles-redirect",
    path: "/admin/missions/:id()/trouver-des-benevoles/redirect",
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/missions/[id]/trouver-des-benevoles/redirect.vue")
  },
  {
    name: "admin-statistics-departements-organisations-a-valider",
    path: "/admin/statistics/departements/organisations-a-valider",
    meta: organisations_45a_45valider7ubSawaPc14_VYc_aDw3BIeuBUTOqk_fycmEm5gOWnIMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/statistics/departements/organisations-a-valider.vue")
  },
  {
    name: "inscription-responsable-step-charte-bon-fonctionnement",
    path: "/inscription/responsable/step/charte-bon-fonctionnement",
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/inscription/responsable/step/charte-bon-fonctionnement.vue")
  },
  {
    name: "inscription-responsable-step-collectivite-confirmation",
    path: "/inscription/responsable/step/collectivite-confirmation",
    meta: collectivite_45confirmationZG1RiS0Gm2KkiKo0OJ0W6NKqxWwOl1PvCO4HtCLyhsIMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/inscription/responsable/step/collectivite-confirmation.vue")
  },
  {
    name: "inscription-responsable-step-organisation-confirmation",
    path: "/inscription/responsable/step/organisation-confirmation",
    meta: organisation_45confirmationbr9gntZQ2d84cDWoTJWvlgktPnz0aJmTfunJSdJGnKQMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/inscription/responsable/step/organisation-confirmation.vue")
  },
  {
    name: "admin-statistics-organisations-participations-a-valider",
    path: "/admin/statistics/organisations/participations-a-valider",
    meta: participations_45a_45validerCoQPqFOyzBGChT0kgq1rcn9Vftin7Fwxjlob26b5s_MMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/statistics/organisations/participations-a-valider.vue")
  },
  {
    name: "admin-statistics-organisations-participations-refusees-annulees",
    path: "/admin/statistics/organisations/participations-refusees-annulees",
    meta: participations_45refusees_45annuleesPVjsjs5_45Kvg_2ezZUOYKPE7NLRIVCm8MinPnKnH9fXAMeta || {},
    component: () => import("/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/pages/admin/statistics/organisations/participations-refusees-annulees.vue")
  },
  {
    name: component_45stub7ik1APMsya2rcL6_45udiv1E8Ly4tBlYllsRrv897IzsQMeta?.name,
    path: "/register/volontaire/:pathMatch(.*)",
    component: component_45stub7ik1APMsya2rcL6_45udiv1E8Ly4tBlYllsRrv897IzsQ
  },
  {
    name: component_45stub7ik1APMsya2rcL6_45udiv1E8Ly4tBlYllsRrv897IzsQMeta?.name,
    path: "/register/responsable/:pathMatch(.*)",
    component: component_45stub7ik1APMsya2rcL6_45udiv1E8Ly4tBlYllsRrv897IzsQ
  },
  {
    name: component_45stub7ik1APMsya2rcL6_45udiv1E8Ly4tBlYllsRrv897IzsQMeta?.name,
    path: "/user/settings",
    component: component_45stub7ik1APMsya2rcL6_45udiv1E8Ly4tBlYllsRrv897IzsQ
  },
  {
    name: component_45stub7ik1APMsya2rcL6_45udiv1E8Ly4tBlYllsRrv897IzsQMeta?.name,
    path: "/user/:pathMatch(.*)",
    component: component_45stub7ik1APMsya2rcL6_45udiv1E8Ly4tBlYllsRrv897IzsQ
  },
  {
    name: component_45stub7ik1APMsya2rcL6_45udiv1E8Ly4tBlYllsRrv897IzsQMeta?.name,
    path: "/dashboard/structure/:pathMatch(.*)",
    component: component_45stub7ik1APMsya2rcL6_45udiv1E8Ly4tBlYllsRrv897IzsQ
  },
  {
    name: component_45stub7ik1APMsya2rcL6_45udiv1E8Ly4tBlYllsRrv897IzsQMeta?.name,
    path: "/dashboard/mission/:pathMatch(.*)",
    component: component_45stub7ik1APMsya2rcL6_45udiv1E8Ly4tBlYllsRrv897IzsQ
  },
  {
    name: component_45stub7ik1APMsya2rcL6_45udiv1E8Ly4tBlYllsRrv897IzsQMeta?.name,
    path: "/dashboard/participation/:pathMatch(.*)",
    component: component_45stub7ik1APMsya2rcL6_45udiv1E8Ly4tBlYllsRrv897IzsQ
  },
  {
    name: component_45stub7ik1APMsya2rcL6_45udiv1E8Ly4tBlYllsRrv897IzsQMeta?.name,
    path: "/dashboard/profile/:pathMatch(.*)",
    component: component_45stub7ik1APMsya2rcL6_45udiv1E8Ly4tBlYllsRrv897IzsQ
  },
  {
    name: component_45stub7ik1APMsya2rcL6_45udiv1E8Ly4tBlYllsRrv897IzsQMeta?.name,
    path: "/dashboard/reseaux/:pathMatch(.*)",
    component: component_45stub7ik1APMsya2rcL6_45udiv1E8Ly4tBlYllsRrv897IzsQ
  },
  {
    name: component_45stub7ik1APMsya2rcL6_45udiv1E8Ly4tBlYllsRrv897IzsQMeta?.name,
    path: "/inscription/organisation",
    component: component_45stub7ik1APMsya2rcL6_45udiv1E8Ly4tBlYllsRrv897IzsQ
  },
  {
    name: component_45stub7ik1APMsya2rcL6_45udiv1E8Ly4tBlYllsRrv897IzsQMeta?.name,
    path: "/statistiques",
    component: component_45stub7ik1APMsya2rcL6_45udiv1E8Ly4tBlYllsRrv897IzsQ
  },
  {
    name: component_45stub7ik1APMsya2rcL6_45udiv1E8Ly4tBlYllsRrv897IzsQMeta?.name,
    path: "/activites/accompagnement-aux-activites-sportives",
    component: component_45stub7ik1APMsya2rcL6_45udiv1E8Ly4tBlYllsRrv897IzsQ
  },
  {
    name: component_45stub7ik1APMsya2rcL6_45udiv1E8Ly4tBlYllsRrv897IzsQMeta?.name,
    path: "/sitemap.xml",
    component: component_45stub7ik1APMsya2rcL6_45udiv1E8Ly4tBlYllsRrv897IzsQ
  }
]